import { create } from 'zustand';

/**
 * Backtest / Equity Store (MEIC-compatible)
 * ----------------------------------------
 * Responsibilities:
 * 1. Normalize WS payload ONCE
 * 2. Enforce stable data contract
 * 3. Do NOT derive chart logic
 * 4. Do NOT split backtest/live
 *
 * Final row shape GUARANTEED:
 * {
 *   id: number | null
 *   date: 'YYYY-MM-DD'
 *   equity: number
 *   daily_pnl: number | null
 *   daily_return: number | null
 *   source: 'BACKTEST' | 'LIVE'
 * }
 */

function normalizeRow(r) {
  if (!r) return null;

  // --- normalize date ---
  let date = r.date;
  if (date && typeof date === 'string') {
    // if accidentally passed MM/DD/YY, fix it
    if (date.includes('/')) {
      const [m, d, y] = date.split('/');
      const yyyy = y.length === 2 ? `20${y}` : y;
      date = `${yyyy}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
    } else {
      date = date.slice(0, 10);
    }
  }

  return {
    id: r.id ?? null,
    date,
    equity: Number(r.equity),
    daily_pnl: r.daily_pnl !== null && r.daily_pnl !== undefined
      ? Number(r.daily_pnl)
      : null,
    daily_return: r.daily_return !== null && r.daily_return !== undefined
      ? Number(r.daily_return)
      : null,
    source: r.source
  };
}

const useBacktestStore = create((set) => ({
  equitySeries: [],

  /**
   * WS is authoritative.
   * We normalize ONCE here.
   */
  setEquitySeries: (rows) =>
    set({
      equitySeries: Array.isArray(rows)
        ? rows.map(normalizeRow).filter(Boolean)
        : []
    }),

  clearEquitySeries: () =>
    set({ equitySeries: [] })
}));

export default useBacktestStore;

